import { CONFIRMED_BOOKING, RESET_INTERCITY, SET_BOOKING_RESET_TRACKING, SET_BOOKING_TRACKING, SET_INTRACITY, SET_INTRACITY_PACKAGES, SET_INTRACITY_PICKUP_DROP_LOCATION, SET_PARTLOAD, SET_PARTLOAD_PACKAGES, SET_PARTLOAD_PICKUP_DROP_LOCATION, SET_QUICK_ORDER } from "../constants/customerBooking";

const initState = {
  intraCity: {
    type: "IntraCity",
    assetType: "635f8465e50d888000e48839",
    city: null,
    pickDropLocation: [
      {
        id: 0,
        place: {
          placeId: null,
          coordinate: {
            latitude: null,
            longitude: null
          },
          placeValue: '',
          city: '',
          area: '',
          name: '',
          pincode: '',
          formatted_address: ''
        },
        contactPerson: {
          name: '',
          contact: '',
          floor: 0,
          officeName: '',
          nearby_landmark: '',
          pincode: '',
          city: ''
        },
        isSubmited: false,
      },
      {
        id: 1,
        place: {
          placeId: null,
          coordinate: {
            latitude: null,
            longitude: null
          },
          placeValue: '',
          city: '',
          area: '',
          name: '',
          pincode: '',
          formatted_address: ''
        },
        contactPerson: {
          name: '',
          contact: '',
          floor: 0,
          officeName: '',
          nearby_landmark: '',
          pincode: '',
          city: ''
        },
        isSubmited: false,
      },
    ],
    packages: [
      {
        id: 0,
        materialType: null,
        qty: 0,
        codAmount: 0,
        orderNumber: '',
        // packingType: null,
        // size: 0,
        // unit: 0,
        // dimension: {
        //   l: 0,
        //   b: 0,
        //   h: 0
        // },
        // weight: 0,
        // stack: false,
        // haz: false,
        // frag: false,
        fromPlaceRef: 0,
        toPlaceRef: null,
      }
    ],
    paymentMode:"topay",
    intraCityRateType:"EXPRESS",
    booked : false
  },
  partLoad: {
    type: "partLoad",
    city: null,
    pickDropLocation: [
      {
        id: 0,
        place: {
          placeId: null,
          coordinate: {
            latitude: null,
            longitude: null
          },
          placeValue: '',
          city: '',
          area: '',
          name: '',
          pincode: '',
          formatted_address: ''
        },
        contactPerson: {
          name: '',
          contact: '',
          floor: 0,
          officeName: '',
          nearby_landmark: '',
          pincode: '',
          city: ''
        },
        isSubmited: false,
      },
      {
        id: 1,
        place: {
          placeId: null,
          coordinate: {
            latitude: null,
            longitude: null
          },
          placeValue: '',
          city: '',
          area: '',
          name: '',
          pincode: '',
          formatted_address: ''
        },
        contactPerson: {
          name: '',
          contact: '',
          floor: 0,
          officeName: '',
          nearby_landmark: '',
          pincode: '',
          city: ''
        },
        isSubmited: false,
      },
    ],
    packages: [
      {
        id: 0,
        materialType: null,
        qty: 0,
        codAmount: 0,
        orderNumber: '',
        packingType: null,
        size: 0,
        unit: 0,
        dimension: {
          l: 0,
          b: 0,
          h: 0
        },
        weight: 0,
        // stack: false,
        // haz: false,
        // frag: false,
        fromPlaceRef: 0,
        toPlaceRef: null,
      }
    ]
  },
  quickOrder:{
    isOpen:false,
    data :""
  },
  tracking: {
    route: [],
    estimation: []
  }
};

const customerBookingReducer = (
  state: any = initState,
  action: { [k: string]: any }
) => {
  switch (action.type) {
    case SET_INTRACITY_PICKUP_DROP_LOCATION: {
      return {
        ...state,
        intraCity: {...state.intraCity, pickDropLocation: action.payload}
      }
    }
    case SET_INTRACITY_PACKAGES: {
      return {
        ...state,
        intraCity: {...state.intraCity, packages: action.payload}
      }
    }
    case SET_INTRACITY: {
      return {
        ...state,
        intraCity: {
          ...state.intraCity,
          [action.payload.what]: action.payload.val
        }
      }
    }
    case RESET_INTERCITY: {
      return {
        ...state,
        intraCity: {
          ...initState.intraCity
        }
      }
    }
    case SET_PARTLOAD_PICKUP_DROP_LOCATION: {
      return {
        ...state,
        intraCity: {...state.intraCity, pickDropLocation: action.payload}
      }
    }
    case SET_PARTLOAD_PACKAGES: {
      return {
        ...state,
        intraCity: {...state.intraCity, packages: action.payload}
      }
    }
    case SET_PARTLOAD: {
      return {
        ...state,
        intraCity: {
          ...state.intraCity,
          [action.payload.what]: action.payload.val
        }
      }
    }
    case SET_QUICK_ORDER: {
      return {
        ...state,
        quickOrder: {
          ...state.quickOrder,
          [action.payload.what]: action.payload.val
        }
      }
    }
    case SET_BOOKING_TRACKING: {
      return {
        ...state,
        tracking: {
          ...state.tracking,
          ...action.payload
        }
      }
    }
    case SET_BOOKING_RESET_TRACKING: {
      return {
        ...initState
      }
    }
    case CONFIRMED_BOOKING : {
      return {
        ...state,
        intraCity: {
          ...state.intraCity,
          [action.payload.what]: action.payload.val
        }
      }
    }
    default: {
      return state;
    }
  }
};

export default customerBookingReducer;
